import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AvatarAsLetterDirectiveModule } from '@lcms/shared/data-access-user';
import { FormsModule } from '@angular/forms';
import { RessourcesResultComponent } from './components/resultats/ressources-result/ressources-result.component';
import { FormationResultComponent } from './components/resultats/formation-result/formation-result.component';
import { CatalogueResultComponent } from './components/resultats/catalogue-result/catalogue-result.component';
import { DynamicSearchComponentDirective } from './dircetive/dynamic-component.directive';
import { SelectFilterComponent } from '@lcms/shared/lazy-load-select';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { RouterLink } from '@angular/router';


@NgModule({
  declarations: [
    RessourcesResultComponent,
    FormationResultComponent,
    CatalogueResultComponent,
    DynamicSearchComponentDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    InlineSVGModule,
    AvatarAsLetterDirectiveModule,
    FormsModule,
    SelectFilterComponent,
    NgxShimmerLoadingModule,
    RouterLink,
  ],
  exports: [
    DynamicSearchComponentDirective
  ]
})
export class SharedSearchFormationModule {}
